import { render, staticRenderFns } from "./Centers.vue?vue&type=template&id=e0f0d4f8&"
import script from "./Centers.vue?vue&type=script&lang=ts&"
export * from "./Centers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports